export default __webpack_public_path__ + "static/global-2000-ai-f129fc7351d2ca7c31df84993f3e9f56.png";